export enum REJECT_TYPE {
    REJECT = 'REJECT',
    RETURN = 'RETURN'
}